import { navigate } from "gatsby"

const Index = () => {
  navigate("/app")

  return null
}

export default Index
